import React, { useState , useContext, useEffect} from 'react';
import { MaintenanceContext } from '../../MaintenanceContext';
import Form from 'react-bootstrap/Form';
import { Row , Col } from 'react-bootstrap';


function Lubricants({props}) {
  const {maintenance,setMaintenance} = useContext(MaintenanceContext);
  const [detailForm,setDetailForm] = useState({categoria:'',marca:''});
  useEffect( () => {
        setMaintenance({...maintenance,details:detailForm});
     },[detailForm]);


  return (
    <>
        <Row>
            <Col sm={12} md={6}>
                <Form.Group className="mb-3" controlId="marca_lub">
                    <Form.Label>Marca</Form.Label>
                    <Form.Select aria-label="Seleccione"
                    onChange={(event) => setDetailForm({...detailForm, marca:event.currentTarget.value})}
                    required
                    >
                        <option  key={1} value=''>Seleccione</option>
                        {
                            props.find((s)=> s.option_value == 'lubricantes').marcas.map((m) => (
                                <option key={m} value={m}>{m}</option>
                            ))
                        }
                    </Form.Select>
                    <Form.Control.Feedback  type="invalid">
                        Ingresa una marca válida
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col sm={12} md={6}>
                <Form.Group className="mb-3" controlId="categoria_lub">
                    <Form.Label>Categoría</Form.Label>
                    <Form.Select
                        aria-label="Seleccione"
                        onChange={(event) => setDetailForm({...detailForm, categoria:event.currentTarget.value})}
                        required
                        >
                        <option  key={12} value=''>Seleccione</option>
                        {
                            props.find((s)=> s.option_value == 'lubricantes').categoria.map((m) => (
                                <option key={m} value={m}>{m}</option>
                            ))
                        }
                    </Form.Select>
                    <Form.Control.Feedback  type="invalid">
                        Ingresa una categoría válida
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
        </Row>
    </>


  );
}

export default Lubricants;